export const getActivePatientsCount = (state) => state.count

export const getIsLoadingActivePatientsCount = (state) => state.isLoading
